import { toDate } from '@/libs/composables/date'

const types = {
  REQUIRED: 'REQUIRED',
  DEFAULT: 'DEFAULT',
}

class Notification {
  constructor(notification) {
    this.id = notification.id
    this.title = notification.title
    this.content = notification.text
    this.preview = notification.text.replace(/<\/?[^>]+>/gi, '')
    this.time = `${toDate(notification.createdAt, 'short')}`
    this.createdAt = notification.createdAt
    this.isViewed = !!notification.viewedAt

    // т.к. в ивенте updateNotification у нотификации поле type: Number (0 || 1),
    // а при запросе списка у нотификаций поле type: String ('DEFAULT' || 'REQUIRED'),
    // тип нотификации пока проверяется таким условием:
    this.isRequired =
      notification.type === types.REQUIRED || notification.type === 1
    this.isRequiredNotViewed = this.isRequired && !this.isViewed
  }
}

export const NotificationItemDecorator = (item) => {
  return new Notification(item)
}

export const NotificationsListDecorator = (items) => {
  return items.map((item) => {
    return NotificationItemDecorator(item)
  })
}
